// @flow
import { _get, _post } from "./methods";

export default {
  listPreviews: (params: any) => _get("/admin/parties/previews", params),
  two_brewers: {
    listMappings: (params: any) => _get("/admin/parties/two_brewers/mappings", params),
    saveMapping: (params: any) => _post("/admin/parties/two_brewers/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/parties/two_brewers/import_snapshot", params)
  },
  electrowerkz: {
    listMappings: (params: any) => _get("/admin/parties/electrowerkz/mappings", params),
    saveMapping: (params: any) => _post("/admin/parties/electrowerkz/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/parties/electrowerkz/import_snapshot", params)
  },
  fire_vauxhall: {
    listMappings: (params: any) => _get("/admin/parties/fire_vauxhall/mappings", params),
    saveMapping: (params: any) => _post("/admin/parties/fire_vauxhall/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/parties/fire_vauxhall/import_snapshot", params)
  }
};
